import { call, put, all, takeEvery, takeLeading } from 'redux-saga/effects'
import { openModal } from 'reducers/messageReducer';
import { initApi, createApi } from 'apis/MCBPS010Api'
import {
  selectionFileUploadInit,
  setSelectionFileUploadInit,
  selectionFileUploadInsert,
  setUpdateTargetDataInfo,
  setUpdateAgainComfigFlg
} from 'reducers/selectionFileUploadReducer'

function* selectionFileUploadInitSaga(action: ReturnType<typeof selectionFileUploadInit>) {
  try {
    const data = yield call(initApi, action.payload);
    yield put(setSelectionFileUploadInit(data))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

function* selectionFileUploadInsertSaga(action: ReturnType<typeof selectionFileUploadInsert>) {
  try {
    const data = yield call(createApi, action.payload);
    if (data.data.messageInfo != 'Successed') {
      yield put(setUpdateAgainComfigFlg(true))
    }
    yield put(setUpdateTargetDataInfo(data.data))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export default function* selectionFileUploadSaga() {
  yield all([
    takeEvery(selectionFileUploadInit, selectionFileUploadInitSaga),
    takeLeading(selectionFileUploadInsert, selectionFileUploadInsertSaga),
  ])
}